import { render, staticRenderFns } from "./YzEmptyStateCard.vue?vue&type=template&id=5715e100&scoped=true&lang=pug&"
import script from "./YzEmptyStateCard.vue?vue&type=script&lang=js&"
export * from "./YzEmptyStateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715e100",
  null
  
)

export default component.exports